import api from "./api";

const getCommands = (search) => {

  return api.get("/mqtt/command",{
    params: {
      ...search
    }
  })
  .then((response) => {
    return response.data;
  });
};

const getCommand = (id) => {

  return api.get("/mqtt/command/"+id)
  .then((response) => {
    return response.data;
  });
};

const getMessages = (search) => {

  return api.get("/mqtt/message",{
    params: {
      ...search
    }
  })
  .then((response) => {
    return response.data;
  });
};

const getMessage = (id) => {

  return api.get("/mqtt/message/"+id)
  .then((response) => {
    return response.data;
  });
};


const MqttService = {
  getCommands,
  getCommand,
  getMessages,
  getMessage,

};

export default MqttService;